import { notify } from "../api/photoshop";
import { useListenFromRenderer } from "../message";

export function useListenNotifyMessage() {
	useListenFromRenderer([
		{
			key: "notify",
			onMessage: (msg) => {
				const { message } = msg.values;
				if (message) {
					notify(message);
				}
			},
		},
	]);
}
